/**
 * JCTCTAS-152: standalone Vite entry for modules/staff.js -- split out of
 * common.js so it only downloads on a page whose Universal Text Page
 * `content_sections` actually has a `staff_section` row (see
 * inc/scripts.php's jctc_layout_conditional_scripts()) -- the JS
 * counterpart to `jctc-staff-section`'s CSS, already split the same way by
 * JCTCTAS-77. See entries/hero-video-viewport.js's own doc comment for why
 * no `$(document).ready()` wrapper is needed.
 */
import initStaffModal from '../modules/staff.js';

document.addEventListener('DOMContentLoaded', initStaffModal);
